var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { refreshToken } from "../containers/pages/OnBoarding/Login/LoginService";
import { Constants } from "./Constants";
export const BASE_URL = Constants.REACT_APP_API_BASE_URL;
console.log("BASE_URL", BASE_URL);
const AUTH_TOKEN_KEY = "accessToken";
// ─────────────────────────────────────────────────────────────
// Axios Instances
// ─────────────────────────────────────────────────────────────
const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/json",
        "x-api-version": 1,
        "X-ZIPPYY-SECRET": "s3kR8g0D@s|-|7EC|-|90L06I35",
        "x-order-admin-secret": "s3kR8g0D@s|-|7EC|-|90L06I35",
        "x-payment-secret": "s3kR8g0D@s|-|7EC|-|90L06I35",
    },
});
const axiosInstanceCompany = axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/json",
        "x-api-version": 1,
        "X-ZIPPYY-SECRET": "zippyy_UUI4raSYK1UwnbvJXfefRaUGDgySCb2Q2bWNZ4sM0bEBb791KQHd7kRaK",
    },
});
const formAxiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "multipart/form-data",
        "X-ZIPPYY-SECRET": "s3kR8g0D@s|-|7EC|-|90L06I35",
    },
});
// ─────────────────────────────────────────────────────────────
// Token Expiry Check
// ─────────────────────────────────────────────────────────────
export const isTokenExpired = (accessToken) => {
    if (!accessToken) {
        return true;
    }
    try {
        const tokenPayload = JSON.parse(atob(accessToken.split(".")[1]));
        const expirationTime = tokenPayload.exp;
        const now = Date.now() / 1000;
        return expirationTime < now;
    }
    catch (error) {
        console.error("Invalid token:", error);
        return true;
    }
};
// ─────────────────────────────────────────────────────────────
// Common Auth Interceptor
// ─────────────────────────────────────────────────────────────
const attachAuthInterceptor = (instance) => {
    instance.interceptors.request.use((config) => __awaiter(void 0, void 0, void 0, function* () {
        const authToken = localStorage.getItem(AUTH_TOKEN_KEY);
        if (authToken) {
            try {
                let updatedToken = authToken;
                // Refresh token if expired
                if (isTokenExpired(authToken)) {
                    updatedToken = (yield refreshToken());
                }
                // Decode token
                const decodedToken = jwtDecode(updatedToken);
                // Add Authorization only if ta_state is true
                if ((decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.ta_state) === true) {
                    config.headers["Authorization"] = `Bearer ${updatedToken}`;
                }
            }
            catch (error) {
                console.error("Error handling token:", error);
            }
        }
        return config;
    }), (error) => Promise.reject(error));
};
// Attach interceptors
attachAuthInterceptor(axiosInstance);
attachAuthInterceptor(axiosInstanceCompany);
attachAuthInterceptor(formAxiosInstance);
// ─────────────────────────────────────────────────────────────
// API Methods
// ─────────────────────────────────────────────────────────────
const APIIN = {
    formUpload: (endpoint, payload) => formAxiosInstance.post(endpoint, payload).then((response) => response.data),
    get: (endpoint, payload) => axiosInstance.get(endpoint, { params: payload }).then((response) => response.data),
    getCompany: (endpoint, payload) => axiosInstanceCompany.get(endpoint, { params: payload }).then((response) => response.data),
    post: (endpoint, payload) => axiosInstance.post(endpoint, payload).then((response) => response.data),
    postCompany: (endpoint, payload) => axiosInstanceCompany.post(endpoint, payload).then((response) => response.data),
    put: (endpoint, payload) => axiosInstance.put(endpoint, payload).then((response) => response.data),
    putCompany: (endpoint, payload) => axiosInstanceCompany.put(endpoint, payload).then((response) => response.data),
    delete: (endpoint) => axiosInstance.delete(endpoint).then((response) => response.data),
    downloadLabel: (endpoint, payload) => axiosInstance
        .get(endpoint, {
        params: payload,
        responseType: "blob",
    })
        .then((response) => response.data),
    sse: (endpoint) => axiosInstance
        .get(endpoint, {
        headers: {
            accept: "text/event-stream",
            "cache-control": "no-cache",
        },
    })
        .then((response) => response.data),
};
export default APIIN;
